export default __webpack_public_path__ + "static/searchcustomization-snapshot-d531937d846ef474f7d9aeb244f2c2c9.jpg";